import React, { useRef, useState, useEffect, useContext } from "react"

import { requestGapi } from "@utils/request"
import { collectionId, siteUrl, imageUrl } from "@config"
import CommonContext from "@src/context"
import classNames from "@utils/classnames"
import Clickable from "@components/clickable"

import styles from "./header.module.scss"
import logoImg from "@images/header.png"
import playImg from "@images/play.png"
import closeImg from "@images/close.png"
import videoAsset from "@images/video.mp4"
import videoBgAsset from "@images/header.mp4"

const Header = () => {
  const { scrollY } = useContext(CommonContext)
  const video = useRef(null)
  const bgVideo = useRef(null)
  const [played, setPlayed] = useState(false)
  const [data, setData] = useState(null)
  const scrollVisible = scrollY < 200
  const videoEndedEvent = () => {
    setPlayed(false)
  }

  useEffect(() => {
    if (played) {
      video.current.addEventListener("ended", videoEndedEvent)
    }
    return () => {
      if (video.current) {
        video.current.removeEventListener("ended", videoEndedEvent)
      }
    }
  }, [played])

  useEffect(() => {
    requestGapi(
      `collections/${collectionId}/originals?page[limit]=2&page[offset]=0&sort=-published-at&include=category,user`
    ).then(res => {
      const data = res?.data
      if (data && data.length > 0) {
        setData(data)
      }
    })

    if (typeof window.WeixinJSBridge === "undefined") {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          bgVideo.current && bgVideo.current.play()
        },
        false
      )
    } else {
      window.WeixinJSBridge.invoke(
        "getNetworkType",
        {},
        function(e) {
          bgVideo.current && bgVideo.current.play()
        },
        false
      )
    }
  }, [])

  return (
    <div className={styles.header}>
      <div className={styles.inner}>
        {played && (
          <div className={styles.video}>
            <Clickable
              className={styles.close}
              onClick={() => {
                setPlayed(false)
              }}
            >
              <img src={closeImg} />
            </Clickable>
            <div className={styles.videoTip}>
              请使用浏览器横屏观看视频以获得最好的体验
            </div>
            <video ref={video} playsInline>
              <source src={videoAsset} type="video/mp4" />
            </video>
          </div>
        )}
        {!played && (
          <>
            <div className={styles.headerBg}>
              <video ref={bgVideo} muted autoPlay loop="loop" playsInline>
                <source src={videoBgAsset} type="video/mp4" />
              </video>
            </div>
            <Clickable
              onClick={() => {
                window.scrollTo(0, window.innerHeight - 200)
              }}
              className={classNames(styles.scroll, {
                [styles.scrollHidden]: !scrollVisible,
              })}
            />
            <div className={styles.content}>
              <img src={logoImg} alt="logo" className={styles.logo} />
              <Clickable
                className={styles.explore}
                onClick={() => {
                  setPlayed(true)
                  setTimeout(() => {
                    if (video.current) {
                      video.current.play()
                    }
                  }, 300)
                }}
              >
                <img className={styles.play} src={playImg} />
                <span>EXPLORE</span>
              </Clickable>
              <p className={styles.intro}>
                火花锦标赛（ Spark Game Champions
                ）是自2019年起机核与华奥电竞合作举办的主机电竞赛事，2020年将有贯穿全年度的线上、线下硬核常规比赛，我们将用更加硬核的赛制和规则来考验大家；但同时还有能够让各位玩家一同参与的各种主题娱乐赛事。现第四赛季正在举行中，期待大家的加入～
                <br />
                <br />
                Spark Game Champions is the main esports competition that
                GAMECORE held in cooperation with Hua Ao (CGA) since 2019. In
                2020, there will be regular online and offline hardcore
                competitions throughout the year, we will test everyone with
                more hardcore competition system and rules, but also a variety
                of themed entertainment events for players to participate. Now
                that the 4th season is underway, we want you to join us.
              </p>
            </div>
          </>
        )}
      </div>
      <div
        className={classNames(styles.news, {
          [styles.newsShowing]: data,
        })}
      >
        <h1>NEWS</h1>
        <div className={styles.newsContainer}>
          {data &&
            data.map(a => {
              return (
                <Clickable
                  key={a.id}
                  href={`${siteUrl}/${a.type}/${a.id}`}
                  className={styles.newsItem}
                >
                  <h1>
                    <span>NEWS</span>
                    <span>
                      {new Date(a.attributes["published-at"]).getMonth() + 1}.
                      {new Date(a.attributes["published-at"]).getDate()}
                    </span>
                  </h1>
                  <img
                    src={`${imageUrl}/${a.attributes.thumb}?x-oss-process=image/resize,limit_1,m_fill,w_248,h_116/quality,q_90`}
                  />
                  <p>{a.attributes.title}</p>
                </Clickable>
              )
            })}
        </div>
        <Clickable
          href={`https://www.gcores.com/collections/${collectionId}`}
          className={styles.moreArticles}
        >
          查看更多
        </Clickable>
      </div>
    </div>
  )
}

export default Header
